/**************
 Global
 ***************/

// get index of a specific element
function getElIndex(el) {
    let i;
    for (i = 0; el = el.previousElementSibling; i++) ;
    return i;
}

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    // pixels
    try {
        _learnq.push(['track', 'Added to Cart', item])
    } catch (e) {
        // skip
    }

    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 };
function changeProduct(formData) {
    return fetch('/cart/change.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
function updateCart(formData) {
    return fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//download product
function downloadProduct(handle) {
    return fetch(`/products/${handle}.js`)
        .then(function (data) {
            return data.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            return false;
        });
}


// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// Debounce
function debounce(func, time = 100) {
    let timer;
    return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, time, event);
    };
}


// open tooltip dialog
function openTooltip(id) {
    // open dialog
    document.querySelector(`#tooltip-${id}`).showModal();
    document.querySelector("body").classList.add("noScroll");
}

// open tooltip event listener
if (window.window.innerWidth < 801) {
    document.querySelectorAll(".openTooltip").forEach(function (element) {
        element.addEventListener("click", function () {
            openTooltip(this.dataset.id);
        });
    });
}

// close tooltip
function closeToolTip(id) {
    document.querySelector("body").classList.remove("noScroll");
    document.querySelector(`#tooltip-${id}`).close();
}

//close tooltip listener
document.querySelectorAll(".tooltipDialogHeaderClose").forEach(function (element) {
    element.addEventListener("click", function () {
        closeToolTip(this.dataset.id);
    });
});


/*************
 Wishlist
 *************/


// check for addToWishlist items on page load
document.querySelectorAll('.addToWishlist')?.forEach(async function (element) {
    // check if item is in wishlist
    await getWishList().then(function (wishlist) {
        // if it is, show the icon heart filled, hide the outline heart
        if (wishlist.includes(element.dataset.handle)) {
            element.querySelector('.addToWishlistOutline').classList.add("active");
            element.querySelector('.addToWishlistFill').classList.remove("active");
        }

    });

});

// wishlist listener
// only visible to logged in customers
document.querySelectorAll('.addToWishlist')?.forEach(function (element) {
    element.addEventListener('click', async function () {

        // check if item is in wishlist, if so remove it, else add it
        if (element.querySelector('.addToWishlistOutline').classList.contains("active")) {
            element.querySelector('.addToWishlistOutline').classList.remove("active");
            element.querySelector('.addToWishlistFill').classList.add("active");
            await removeFromWishlist(this.dataset.product);
            return;
        }

        // add to wishlist
        element.querySelector('.addToWishlistOutline').classList.add("active");
        element.querySelector('.addToWishlistFill').classList.remove("active");
        await addToWishList(this.dataset.product);

        // show added message
        element.querySelector('.addToWishlistMsg').classList.add("active");

        setTimeout(function () {
                element.querySelector('.addToWishlistMsg').classList.remove("active");
            }, 1000
        );


    });
});


// add product to wishlist
// user must be logged in to add to wishlist
function addToWishList(id) {
    // build data
    const data = {
        customer_id: customerID,
        product_id: id
    };
    // send id to wishlist API
    fetch("https://api.audryrosejewelry.com/public/wishlist/add.php", {
        method: 'POST',
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch(error => console.error('Error:', error));
}


// get wishlist
async function getWishList() {
    let wishlist = [];
    // build data
    const data = {
        customer_id: customerID,
        handles: true
    };

    // request wishlist
    await fetch('https://api.audryrosejewelry.com/public/wishlist/get.php', {
        method: 'POST',
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .then(data => {
            // build wishlist array
            for (let item of data.wishlist) wishlist.push(item);
        })
        .catch(error => console.error('Error:', error));

    // return wishlist
    return wishlist;
}

// remove wishlist item
function removeFromWishlist(id) {
    // build data
    const data = {
        customer_id: customerID,
        product_id: id
    };
    // request delete of item
    fetch('https://api.audryrosejewelry.com/public/wishlist/remove.php', {
        method: 'POST',
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .catch(error => console.error('Error:', error));
}


// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

/**
 * Get inventory status for a given SKU from IMS. This is used to determine if the product is in stock or sold out.
 * @param sku
 * @returns {Promise<any>}
 */
async function getInventoryStatus(sku) {
    // fetch inventory status
    return await fetch(`https://api.audryrosejewelry.com/public/get-inventory.php?sku=${sku}`).then(response => response.json());
}